
import { Union } from "../../fable_modules/fable-library-js.5.3.0/Types.js";
import { class_type, union_type, list_type, option_type, string_type } from "../../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.3.0/Option.js";
import { IconWeight, IconSize, icon as icon_1, IconName } from "../Icons.js";
import { HtmlHelper_createElement } from "../../fable_modules/Feliz.3.3.3/Html.fs.js";
import { padding_py8, fontWeight_fontMedium, fontSize_textLg, backgroundColor_bgNeutral100, margin_mxAuto, maxWidth_w2Xl, padding_py3, borderRadius_roundedMd, margin_mb3, gap_gap$002D4, grid_cols$002D2, display_grid, borderWidth_borderT, height_h2, margin_mb4, height_h3, justifyContent_justifyBetween, boxShadow_shadowMd, gap_gap$002D3, alignItems_itemsStart, border_border, padding_p6, width_w24, borderRadius_roundedLg, height_h5, height_h10, width_w10, height_h8, width_w8, height_h6, borderRadius_rounded, animation_animatePulse, backgroundColor_bgNeutral200, height_h4, width_wFull, width_w3$002F4, width_w2$002F3, width_w1$002F2, width_w1$002F3, width_w1$002F4, border_borderB2, width_w12, height_h12, animation_animateSpin, padding_py2, padding_px4, flexGrow_flexGrow, padding_p4, fontSize_textSm, gap_gap$002D1, margin_mt1, flex_flexRow, gap_gap$002D2, height_h16, width_w16, gap_gap$002D6, textAlign_center, justifyContent_justifyCenter, alignItems_itemsCenter, flex_flexCol, display_flex, margin_mb2, fontWeight_fontBold, fontSize_text2Xl, whitespace_whitespacePreLine, fontSize_textBase, tw } from "../../fable_modules/Feliz.Tailwind.4.0.2/Strings.fs.js";
import { md, borderColor_borderNeutral100, borderColor_borderNeutral200, backgroundColor_bgSurface, borderColor_borderPrimary600, textColor_textDanger800, borderColor_borderDanger500, backgroundColor_bgDanger50, textColor_textDanger600, gap_gap4, sm, backgroundColor_bgDanger100, borderRadius_roundedFull, padding_py16, textColor_textNeutral900, space_spaceY2, textColor_textNeutral600 } from "../TailwindExtensions.js";
import { empty as empty_1, append as append_1, isEmpty, singleton, ofArray } from "../../fable_modules/fable-library-js.5.3.0/List.js";
import { collect, empty, singleton as singleton_1, append, map, delay, toList } from "../../fable_modules/fable-library-js.5.3.0/Seq.js";
import { LayoutType, pageContainer, TailwindHelpers_linkSecondary, TailwindHelpers_buttonPrimary } from "./Layout.js";
import { createElement } from "react";
import { join } from "../../fable_modules/fable-library-js.5.3.0/String.js";
import { createObj } from "../../fable_modules/fable-library-js.5.3.0/Util.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.5.3.0/Range.js";

/**
 * Different types of errors that can occur in page-level interactions
 */
export class PageErrorKind extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotFound", "NetworkError", "ServerError", "Unauthorized", "ValidationError"];
    }
}

export function PageErrorKind_$reflection() {
    return union_type("Shared.Interactions.PageErrorKind", [], PageErrorKind, () => [[["message", option_type(string_type)]], [["message", option_type(string_type)]], [["message", option_type(string_type)]], [], [["errors", list_type(string_type)]]]);
}

function errorKindProps(errorKind) {
    switch (errorKind.tag) {
        case 1: {
            const desc_1 = defaultArg(errorKind.fields[0], "Unable to connect. Please check your internet connection and try again.");
            return [new IconName(56, []), "Connection Error", HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral600, whitespace_whitespacePreLine]))], ["children", singleton(desc_1)]])), true];
        }
        case 2: {
            const desc_2 = defaultArg(errorKind.fields[0], "Something went wrong on our end. Please try again later.");
            return [new IconName(34, []), "Server Error", HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral600, whitespace_whitespacePreLine]))], ["children", singleton(desc_2)]])), true];
        }
        case 3:
            return [new IconName(33, []), "Access Denied", HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral600, whitespace_whitespacePreLine]))], ["children", singleton("You don\'t have permission to view this page. Please sign in or contact support.")]])), false];
        case 4: {
            const errors = errorKind.fields[0];
            return [new IconName(7, []), "Validation Error", isEmpty(errors) ? HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral600]))], ["children", singleton("Please fix the errors and try again.")]])) : HtmlHelper_createElement("ul", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral600, "list-disc", "list-inside", space_spaceY2]))], ["children", toList(delay(() => map((error) => HtmlHelper_createElement("li", singleton(["children", singleton(error)])), errors)))]])), false];
        }
        default: {
            const desc = defaultArg(errorKind.fields[0], "The page you\'re looking for doesn\'t exist or has been moved.");
            return [new IconName(57, []), "Page Not Found", HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral600, whitespace_whitespacePreLine]))], ["children", singleton(desc)]])), false];
        }
    }
}

function defaultActions(showRetry, onRetry, ctaText, ctaHref) {
    return toList(delay(() => {
        let retryAction;
        return append(showRetry ? ((onRetry != null) ? ((retryAction = onRetry, singleton_1(HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", TailwindHelpers_buttonPrimary], ["children", singleton("Try Again")], ["onClick", (_arg) => {
            retryAction();
        }]]))))) : (empty())) : (empty()), delay(() => singleton_1(HtmlHelper_createElement("a", ofArray([["className", TailwindHelpers_linkSecondary], ["href", ctaHref], ["children", singleton(ctaText)]])))));
    }));
}

/**
 * Renders a page-level error without container wrapping.
 * When customActions is None, renders default actions (Go to Home link).
 * When customActions is Some, renders only the provided action elements.
 * When iconOverride is Some, uses that icon instead of the error kind's default.
 * When titleOverride is Some, uses that title instead of the error kind's default.
 * When headingLevel is Some n, uses that heading level (e.g. 2 for h2) instead of h1.
 * Use headingLevel = Some 2 when embedding inside a page that already has an h1.
 */
export function pageErrorContent(errorKind, customActions, iconOverride, titleOverride, headingLevel) {
    const patternInput = errorKindProps(errorKind);
    const title = defaultArg(titleOverride, patternInput[1]);
    const iconName = defaultArg(iconOverride, patternInput[0]);
    const actions_1 = (customActions == null) ? defaultActions(false, undefined, "Go to Home", "/") : customActions;
    const headingClasses = ["className", tw(ofArray([fontSize_text2Xl, fontWeight_fontBold, textColor_textNeutral900, margin_mb2]))];
    const headingElement = (headingLevel != null) ? ((headingLevel === 2) ? HtmlHelper_createElement("h2", ofArray([headingClasses, ["children", singleton(title)]])) : ((headingLevel === 3) ? HtmlHelper_createElement("h3", ofArray([headingClasses, ["children", singleton(title)]])) : ((headingLevel === 4) ? HtmlHelper_createElement("h4", ofArray([headingClasses, ["children", singleton(title)]])) : ((headingLevel === 5) ? HtmlHelper_createElement("h5", ofArray([headingClasses, ["children", singleton(title)]])) : ((headingLevel === 6) ? HtmlHelper_createElement("h6", ofArray([headingClasses, ["children", singleton(title)]])) : HtmlHelper_createElement("h1", ofArray([headingClasses, ["children", singleton(title)]]))))))) : HtmlHelper_createElement("h1", ofArray([headingClasses, ["children", singleton(title)]]));
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, textAlign_center, padding_py16, gap_gap$002D6]))], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, width_w16, height_h16, borderRadius_roundedFull, backgroundColor_bgDanger100]))], ["children", [createElement(icon_1, {
        name: iconName,
        size: new IconSize(2, []),
        weight: new IconWeight(0, []),
    })]]]))), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, gap_gap$002D2]))], ["children", [headingElement, patternInput[2]]]]))), delay(() => {
        if (isEmpty(actions_1)) {
            return empty();
        }
        else {
            return singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, sm(flex_flexRow), gap_gap4, alignItems_itemsCenter, justifyContent_justifyCenter]))], ["children", actions_1]])));
        }
    }))))))]]));
}

/**
 * Renders a page-level error with appropriate icon, messaging, and actions.
 * Wraps the error content in a narrow pageContainer.
 * iconOverride replaces the default icon for the error kind.
 * ctaText/ctaHref override the default "Go to Home" / "/" link.
 * title overrides the default title for the error kind.
 */
export class PageError {
    constructor() {
    }
}

export function PageError_$reflection() {
    return class_type("Shared.Interactions.PageError", undefined, PageError);
}

export function PageError_render_Z70A9CE70(errorKind, onRetry, icon, ctaText, ctaHref, title) {
    return pageContainer(new LayoutType(3, []), singleton(pageErrorContent(errorKind, defaultActions(errorKindProps(errorKind)[3], onRetry, defaultArg(ctaText, "Go to Home"), defaultArg(ctaHref, "/")), icon, title, undefined)));
}

/**
 * Renders a page-level error with appropriate icon, messaging, and actions.
 * Wraps the error content in a narrow pageContainer.
 */
export function pageError(errorKind, onRetry) {
    return PageError_render_Z70A9CE70(errorKind, onRetry);
}

/**
 * Field-level error text with XCircle icon and role="alert" (Tier 1)
 */
export function inlineError(error) {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["alert"])], ["className", tw(ofArray([margin_mt1, display_flex, alignItems_itemsCenter, gap_gap$002D1, fontSize_textSm, textColor_textDanger600]))], ["children", [createElement(icon_1, {
        name: new IconName(7, []),
        size: new IconSize(0, []),
        weight: new IconWeight(1, []),
    }), HtmlHelper_createElement("span", singleton(["children", singleton(error)]))]]]));
}

/**
 * Section-level error banner with Warning icon, border-l-4 accent, and optional retry (Tier 2)
 */
export function sectionError(error, onRetry) {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["alert"])], ["className", tw(ofArray([backgroundColor_bgDanger50, "border-l-4", borderColor_borderDanger500, padding_p4, "rounded-r-md", display_flex, alignItems_itemsCenter, gap_gap$002D2]))], ["children", toList(delay(() => append(singleton_1(createElement(icon_1, {
        name: new IconName(34, []),
        size: new IconSize(1, []),
        weight: new IconWeight(1, []),
    })), delay(() => append(singleton_1(HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textDanger800, flexGrow_flexGrow]))], ["children", singleton(error)]]))), delay(() => {
        const matchValue = onRetry;
        if (matchValue == null) {
            return empty();
        }
        else {
            const retry = matchValue;
            return singleton_1(HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", tw(ofArray([TailwindHelpers_buttonPrimary, fontSize_textSm, padding_px4, padding_py2]))], ["children", singleton("Try Again")], ["onClick", (_arg) => {
                retry();
            }]])));
        }
    }))))))]]));
}

export const centeredSpinner = HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading"], ["className", tw(ofArray([display_flex, justifyContent_justifyCenter, alignItems_itemsCenter, padding_py16]))], ["children", [HtmlHelper_createElement("div", singleton(["className", tw(ofArray([animation_animateSpin, borderRadius_roundedFull, height_h12, width_w12, border_borderB2, borderColor_borderPrimary600]))]))]]]));

function widthClass(widthPercent) {
    let matchResult;
    if (widthPercent != null) {
        switch (widthPercent) {
            case 25: {
                matchResult = 0;
                break;
            }
            case 33: {
                matchResult = 1;
                break;
            }
            case 50: {
                matchResult = 2;
                break;
            }
            case 66: {
                matchResult = 3;
                break;
            }
            case 75: {
                matchResult = 4;
                break;
            }
            case 100: {
                matchResult = 5;
                break;
            }
            default:
                matchResult = 6;
        }
    }
    else {
        matchResult = 6;
    }
    switch (matchResult) {
        case 0:
            return width_w1$002F4;
        case 1:
            return width_w1$002F3;
        case 2:
            return width_w1$002F2;
        case 3:
            return width_w2$002F3;
        case 4:
            return width_w3$002F4;
        case 5:
            return width_wFull;
        default:
            return width_w3$002F4;
    }
}

/**
 * Basic skeleton line for text content
 * @param widthPercent - Optional width percentage (25, 33, 50, 66, 75, 100). Defaults to 75%.
 */
export function skeletonLine(widthPercent) {
    return HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["className", tw(ofArray([height_h4, backgroundColor_bgNeutral200, animation_animatePulse, borderRadius_rounded, widthClass(widthPercent)]))]]));
}

/**
 * Skeleton heading (wider line)
 * @param widthPercent - Optional width percentage. Defaults to 50%.
 */
export function skeletonHeading(widthPercent) {
    return HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["className", tw(ofArray([height_h6, backgroundColor_bgNeutral200, animation_animatePulse, borderRadius_rounded, widthClass(defaultArg(widthPercent, 50))]))]]));
}

/**
 * Skeleton avatar (circular placeholder)
 * @param size - Optional size: "sm" (8), "lg" (12), "xl" (16). Defaults to medium (10).
 */
export function skeletonAvatar(size) {
    return HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["className", tw(append_1(ofArray([backgroundColor_bgNeutral200, animation_animatePulse, borderRadius_roundedFull]), (size != null) ? ((size === "sm") ? ofArray([width_w8, height_h8]) : ((size === "lg") ? ofArray([width_w12, height_h12]) : ((size === "xl") ? ofArray([width_w16, height_h16]) : ofArray([width_w10, height_h10])))) : ofArray([width_w10, height_h10])))]]));
}

/**
 * Skeleton badge (small pill)
 * Represents loading state for small pill-shaped elements like status badges
 */
export function skeletonBadge() {
    return HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["className", tw(ofArray([height_h5, backgroundColor_bgNeutral200, animation_animatePulse, borderRadius_roundedFull, width_w16]))]]));
}

/**
 * Skeleton button (pill shape)
 * @param widthPx - Optional width in pixels. Defaults to w-24 if not specified.
 */
export function skeletonButton(widthPx) {
    const widthStyle = (widthPx == null) ? empty_1() : singleton(["width", widthPx]);
    return HtmlHelper_createElement("div", toList(delay(() => append(singleton_1(["aria-hidden", true]), delay(() => append(singleton_1(["className", tw(toList(delay(() => append(singleton_1(height_h10), delay(() => append(singleton_1(backgroundColor_bgNeutral200), delay(() => append(singleton_1(animation_animatePulse), delay(() => append(singleton_1(borderRadius_roundedLg), delay(() => ((widthPx == null) ? singleton_1(width_w24) : singleton_1("")))))))))))))]), delay(() => (!isEmpty(widthStyle) ? singleton_1(["style", createObj(widthStyle)]) : empty()))))))));
}

/**
 * Pre-built skeleton compositions for common UI patterns.
 * Skeleton card with avatar, heading, and content lines
 * Useful for loading states in card-based layouts like challenge cards or user profiles
 */
export function skeletonCard() {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading card content"], ["className", tw(ofArray([padding_p6, borderRadius_roundedLg, backgroundColor_bgSurface, border_border, borderColor_borderNeutral200]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, gap_gap4, alignItems_itemsStart]))], ["children", [skeletonAvatar(undefined), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([flexGrow_flexGrow, gap_gap$002D3, display_flex, flex_flexCol]))], ["children", [skeletonHeading(undefined), skeletonLine(100), skeletonLine(75)]]]))]]]))]]]));
}

/**
 * Skeleton challenge card matching the ChallengeList card anatomy
 * Includes title + badge row, theme, progress bar, pledger count, divider, stats grid, and CTA
 */
export function skeletonChallengeCard() {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading challenge card"], ["className", tw(ofArray([backgroundColor_bgSurface, borderRadius_roundedLg, boxShadow_shadowMd, padding_p6, animation_animatePulse]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, justifyContent_justifyBetween, alignItems_itemsStart, margin_mb2]))], ["children", [HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h4, backgroundColor_bgNeutral200, borderRadius_rounded, width_w3$002F4]))])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h4, backgroundColor_bgNeutral200, borderRadius_roundedFull, width_w16]))]))]]])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h3, backgroundColor_bgNeutral200, borderRadius_rounded, width_w1$002F2, margin_mb4]))])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h2, backgroundColor_bgNeutral200, borderRadius_rounded, width_wFull, margin_mb4]))])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h3, backgroundColor_bgNeutral200, borderRadius_rounded, width_w1$002F3, margin_mb4]))])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([borderWidth_borderT, borderColor_borderNeutral100, margin_mb4]))])), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_grid, grid_cols$002D2, gap_gap$002D4, margin_mb3]))], ["children", [HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h8, backgroundColor_bgNeutral200, borderRadius_rounded]))])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h8, backgroundColor_bgNeutral200, borderRadius_rounded]))]))]]])), HtmlHelper_createElement("div", singleton(["className", tw(ofArray([height_h8, backgroundColor_bgNeutral200, borderRadius_roundedMd, width_wFull]))]))]]]));
}

/**
 * Skeleton list item with minimal content
 * Ideal for loading states in list views with avatar and text
 */
export function skeletonListItem() {
    return HtmlHelper_createElement("div", ofArray([["aria-hidden", true], ["className", tw(ofArray([padding_py3, display_flex, gap_gap$002D3, alignItems_itemsCenter]))], ["children", [skeletonAvatar("sm"), HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([flexGrow_flexGrow, gap_gap$002D2, display_flex, flex_flexCol]))], ["children", [skeletonLine(50), skeletonLine(33)]]]))]]]));
}

/**
 * Skeleton grid for multiple cards
 * @param columns - Number of columns (1-4). Defaults to 3.
 * @param count - Number of skeleton cards to display
 */
export function skeletonGrid(columns, count) {
    const gridCols = (columns === 1) ? "grid-cols-1" : ((columns === 2) ? "grid-cols-2" : ((columns === 3) ? "grid-cols-3" : ((columns === 4) ? "grid-cols-4" : "grid-cols-3")));
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading grid items"], ["className", tw(ofArray([display_grid, gap_gap4, "grid-cols-1", md(gridCols)]))], ["children", toList(delay(() => collect((matchValue) => singleton_1(skeletonCard()), rangeDouble(1, 1, count))))]]));
}

/**
 * Skeleton list with multiple items
 * @param count - Number of skeleton list items to display
 * Items are separated by divider lines
 */
export function skeletonList(count) {
    return HtmlHelper_createElement("div", ofArray([["role", join(" ", ["status"])], ["aria-label", "Loading list"], ["className", "divide-y divide-neutral-200"], ["children", toList(delay(() => collect((matchValue) => singleton_1(skeletonListItem()), rangeDouble(1, 1, count))))]]));
}

/**
 * Empty states provide clear communication when there's no content to display.
 * They guide users on what to do next with contextual messaging and actions.
 * Full empty state with icon, title, description, and optional action
 * Use for primary empty states like empty lists, search results, or major sections
 * @param iconName - Icon to display (e.g., ListBullets, MagnifyingGlass, Rocket)
 * @param title - Main heading text
 * @param description - Descriptive text explaining the empty state
 * @param actionText - Optional button text
 * @param onAction - Optional click handler for the action button
 */
export function emptyStateFull(iconName, title, description, actionText, onAction) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, textAlign_center, padding_py16, padding_px4, gap_gap$002D6, maxWidth_w2Xl, margin_mxAuto]))], ["children", toList(delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, width_w16, height_h16, borderRadius_roundedFull, backgroundColor_bgNeutral100]))], ["children", [createElement(icon_1, {
        name: iconName,
        size: new IconSize(2, []),
        weight: new IconWeight(0, []),
    })]]]))), delay(() => append(singleton_1(HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, gap_gap$002D2]))], ["children", [HtmlHelper_createElement("h3", ofArray([["className", tw(ofArray([fontSize_textLg, fontWeight_fontMedium, textColor_textNeutral900, margin_mb2]))], ["children", singleton(title)]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textBase, textColor_textNeutral600]))], ["children", singleton(description)]]))]]]))), delay(() => {
        let matchResult, action, text;
        if (actionText != null) {
            if (onAction != null) {
                matchResult = 0;
                action = onAction;
                text = actionText;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return singleton_1(HtmlHelper_createElement("button", ofArray([["type", "button"], ["className", TailwindHelpers_buttonPrimary], ["children", singleton(text)], ["onClick", (_arg) => {
                    action();
                }]])));
            default: {
                return empty();
            }
        }
    }))))))]]));
}

/**
 * Compact empty state with minimal UI
 * Use for secondary empty states within cards, sidebars, or smaller sections
 * @param iconName - Icon to display (smaller than full empty state)
 * @param message - Single line message
 */
export function emptyStateCompact(iconName, message) {
    return HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, flex_flexCol, alignItems_itemsCenter, justifyContent_justifyCenter, textAlign_center, padding_py8, padding_px4, gap_gap4]))], ["children", [HtmlHelper_createElement("div", ofArray([["className", tw(ofArray([display_flex, alignItems_itemsCenter, justifyContent_justifyCenter, width_w12, height_h12, borderRadius_roundedFull, backgroundColor_bgNeutral100]))], ["children", [createElement(icon_1, {
        name: iconName,
        size: new IconSize(1, []),
        weight: new IconWeight(0, []),
    })]]])), HtmlHelper_createElement("p", ofArray([["className", tw(ofArray([fontSize_textSm, textColor_textNeutral600]))], ["children", singleton(message)]]))]]]));
}

//# sourceMappingURL=Interactions.js.map
